"use client"

import React from 'react';
import {useAppStore} from "@/store/AppStore";
import {Link} from "@/i18n/routing";
import {MdLocationCity} from "react-icons/md";
import {Chip} from "@mui/material";

export default function PlaceType(props: { id: string, className: string }) {
  const types = useAppStore((state) => {
    return state.types
  })
  const type = types?.filter(type => {
    return String(type.id) === props.id
  })

  if (!type || type.length === 0) return null
  const currentType = type.pop()
  if (!currentType) return null
  return <Link className={props.className}
               href={`/places/?type=${currentType.id}`}>
    <Chip icon={<MdLocationCity/>} size={"small"}
          label={currentType.name}
          color="primary"
          variant="outlined"/>
  </Link>

}
